import { avatarColorRecipe, avatarFallback, avatarFallbackTextRecipe, avatarIconRecipe, avatarImage, avatarRootRecipe } from "./avatar.styles.js";
import { c } from "react/compiler-runtime";
import { jsx, jsxs } from "react/jsx-runtime";
import { Avatar as Avatar$1 } from "@base-ui/react/avatar";
import { clsx } from "clsx";
//#region src/components/avatar/avatar.tsx
var avatarSizeSmall = 20;
var avatarSizeMedium = 32;
var avatarSizeLarge = 40;
var imageFallbackDelayMs = 600;
var avatarSizeOptions = [
	avatarSizeSmall,
	avatarSizeMedium,
	avatarSizeLarge
];
var avatarColorOptions = [
	"blue",
	"lime",
	"orange",
	"teal",
	"violet"
];
/**
* Avatar renders DS-approved identity primitives for initials, image, and icon content.
*/
var Avatar = (t0) => {
	const $ = c(70);
	let props;
	let t1;
	if ($[0] !== t0) {
		({size: t1, ...props} = t0);
		$[0] = t0;
		$[1] = props;
		$[2] = t1;
	} else {
		props = $[1];
		t1 = $[2];
	}
	const size = t1 === void 0 ? avatarSizeMedium : t1;
	if (props.kind === "image") {
		let alt;
		let color;
		let fallbackInitial;
		let imageProps;
		let kind;
		let otherProps;
		let src;
		if ($[3] !== props) {
			({kind, src, alt, fallbackInitial, imageProps, color, ...otherProps} = props);
			$[3] = props;
			$[4] = alt;
			$[5] = color;
			$[6] = fallbackInitial;
			$[7] = imageProps;
			$[8] = kind;
			$[9] = otherProps;
			$[10] = src;
		} else {
			alt = $[4];
			color = $[5];
			fallbackInitial = $[6];
			imageProps = $[7];
			kind = $[8];
			otherProps = $[9];
			src = $[10];
		}
		const fallbackText = fallbackInitial ?? "NA";
		let t2;
		if ($[11] !== color || $[12] !== kind || $[13] !== size) {
			t2 = clsx(avatarRootRecipe({
				size,
				kind
			}), color === void 0 ? void 0 : avatarColorRecipe({ color }));
			$[11] = color;
			$[12] = kind;
			$[13] = size;
			$[14] = t2;
		} else t2 = $[14];
		let t3;
		if ($[15] !== alt || $[16] !== imageProps || $[17] !== src) {
			t3 = /* @__PURE__ */ jsx(Avatar$1.Image, {
				src,
				alt,
				className: avatarImage,
				...imageProps
			});
			$[15] = alt;
			$[16] = imageProps;
			$[17] = src;
			$[18] = t3;
		} else t3 = $[18];
		let t4;
		if ($[19] !== size) {
			t4 = avatarFallbackTextRecipe({ size });
			$[19] = size;
			$[20] = t4;
		} else t4 = $[20];
		let t5;
		if ($[21] !== fallbackText || $[22] !== t4) {
			t5 = /* @__PURE__ */ jsx("span", {
				className: t4,
				children: fallbackText
			});
			$[21] = fallbackText;
			$[22] = t4;
			$[23] = t5;
		} else t5 = $[23];
		let t6;
		if ($[24] !== alt || $[25] !== t5) {
			t6 = /* @__PURE__ */ jsx(Avatar$1.Fallback, {
				delay: imageFallbackDelayMs,
				className: avatarFallback,
				"aria-label": alt,
				children: t5
			});
			$[24] = alt;
			$[25] = t5;
			$[26] = t6;
		} else t6 = $[26];
		let t7;
		if ($[27] !== otherProps || $[28] !== t2 || $[29] !== t3 || $[30] !== t6) {
			t7 = /* @__PURE__ */ jsxs(Avatar$1.Root, {
				...otherProps,
				className: t2,
				children: [t3, t6]
			});
			$[27] = otherProps;
			$[28] = t2;
			$[29] = t3;
			$[30] = t6;
			$[31] = t7;
		} else t7 = $[31];
		return t7;
	}
	if (props.kind === "icon") {
		let Icon;
		let color_0;
		let iconProps;
		let kind_0;
		let otherProps_0;
		if ($[32] !== props) {
			({kind: kind_0, icon: Icon, iconProps, color: color_0, ...otherProps_0} = props);
			$[32] = props;
			$[33] = Icon;
			$[34] = color_0;
			$[35] = iconProps;
			$[36] = kind_0;
			$[37] = otherProps_0;
		} else {
			Icon = $[33];
			color_0 = $[34];
			iconProps = $[35];
			kind_0 = $[36];
			otherProps_0 = $[37];
		}
		let t2;
		if ($[38] !== color_0 || $[39] !== kind_0 || $[40] !== size) {
			t2 = clsx(avatarRootRecipe({
				size,
				kind: kind_0
			}), color_0 === void 0 ? void 0 : avatarColorRecipe({ color: color_0 }));
			$[38] = color_0;
			$[39] = kind_0;
			$[40] = size;
			$[41] = t2;
		} else t2 = $[41];
		let t3;
		if ($[42] !== size) {
			t3 = avatarIconRecipe({ size });
			$[42] = size;
			$[43] = t3;
		} else t3 = $[43];
		let t4;
		if ($[44] !== Icon || $[45] !== iconProps || $[46] !== t3) {
			t4 = /* @__PURE__ */ jsx(Icon, {
				...iconProps,
				"aria-hidden": "true",
				className: t3
			});
			$[44] = Icon;
			$[45] = iconProps;
			$[46] = t3;
			$[47] = t4;
		} else t4 = $[47];
		let t5;
		if ($[48] !== otherProps_0 || $[49] !== t2 || $[50] !== t4) {
			t5 = /* @__PURE__ */ jsx(Avatar$1.Root, {
				...otherProps_0,
				className: t2,
				children: t4
			});
			$[48] = otherProps_0;
			$[49] = t2;
			$[50] = t4;
			$[51] = t5;
		} else t5 = $[51];
		return t5;
	}
	let color_1;
	let initial;
	let kind_1;
	let otherProps_1;
	if ($[52] !== props) {
		({kind: kind_1, initial, color: color_1, ...otherProps_1} = props);
		$[52] = props;
		$[53] = color_1;
		$[54] = initial;
		$[55] = kind_1;
		$[56] = otherProps_1;
	} else {
		color_1 = $[53];
		initial = $[54];
		kind_1 = $[55];
		otherProps_1 = $[56];
	}
	let t2;
	if ($[57] !== color_1 || $[58] !== kind_1 || $[59] !== size) {
		t2 = clsx(avatarRootRecipe({
			size,
			kind: kind_1 ?? "initial"
		}), color_1 === void 0 ? void 0 : avatarColorRecipe({ color: color_1 }));
		$[57] = color_1;
		$[58] = kind_1;
		$[59] = size;
		$[60] = t2;
	} else t2 = $[60];
	let t3;
	if ($[61] !== size) {
		t3 = clsx(avatarFallback, avatarFallbackTextRecipe({ size }));
		$[61] = size;
		$[62] = t3;
	} else t3 = $[62];
	let t4;
	if ($[63] !== initial || $[64] !== t3) {
		t4 = /* @__PURE__ */ jsx(Avatar$1.Fallback, {
			className: t3,
			children: initial
		});
		$[63] = initial;
		$[64] = t3;
		$[65] = t4;
	} else t4 = $[65];
	let t5;
	if ($[66] !== otherProps_1 || $[67] !== t2 || $[68] !== t4) {
		t5 = /* @__PURE__ */ jsx(Avatar$1.Root, {
			...otherProps_1,
			className: t2,
			children: t4
		});
		$[66] = otherProps_1;
		$[67] = t2;
		$[68] = t4;
		$[69] = t5;
	} else t5 = $[69];
	return t5;
};
//#endregion
export { Avatar, avatarColorOptions, avatarSizeOptions };
